/** Shared horizontal inset for profile chrome rows inside `@container/entity-profile`. */
export const ENTITY_PROFILE_HORIZONTAL_INSET_CLASS =
    "px-ds-space-200 @sm/entity-profile:px-ds-space-300";

/** Header top inset — matches horizontal step at comfortable container width. */
export const ENTITY_PROFILE_HEADER_TOP_INSET_CLASS =
    "pt-ds-space-200 @sm/entity-profile:pt-ds-space-300";
